export default {
  GET_BRIGADE: state => state.brigade,
  GET_ONE_BRIGADE: state => state.one_brigade,
}
